import { Outlet } from 'react-router'

import type { JudgeUser } from '@app/shared/types/entities'

import { useAuth } from '@/shared/contexts/AuthContext'
import { ConnectionIndicator } from '@/shared/components/ConnectionIndicator'
import { CompetitionSSEProvider } from '@/features/notifications'
import { useOfflineSync } from '@/features/scoring/hooks/useOfflineSync'
import { useScorePrefetch } from '@/features/scoring/hooks/useScorePrefetch'

export function JudgeLayout(): React.ReactElement {
  const { user } = useAuth()
  const judge = user as JudgeUser

  // Sync dirty scoring data + offline activations to the server on reconnect (controls the gate)
  useOfflineSync(judge.competitionId)

  // Prefetch all my-score for assigned students (for offline navigation)
  useScorePrefetch(judge.competitionId)

  return (
    <CompetitionSSEProvider competitionId={judge.competitionId}>
      <div className="mx-auto flex min-h-screen w-full max-w-xl flex-col">
        {/* Connection indicator */}
        <ConnectionIndicator />

        {/* Top bar — hidden on scoring page (scoring screen has its own header) */}

        {/* Page content */}
        <main className="flex flex-1 flex-col p-2">
          <Outlet />
        </main>
      </div>
    </CompetitionSSEProvider>
  )
}
